var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import MD from "markdown-to-jsx";
import stripHtml from "string-strip-html";
import { IconRenderer } from "./renderers/IconRenderer";
import { LinkRenderer } from "./renderers/LinkRenderer";
import { DateRenderer } from "./renderers/DateRenderer";
import { StateNameRenderer } from "./renderers/StateNameRenderer";
import { ModalRenderer } from "./renderers/ModalRenderer";
import { parse } from "./template";
var TEMPLATE_PARSER_OPTS = {
    regex: /\[{2}(.+?)\]{2}/g,
    skipUndefined: true,
    throwOnUndefined: false,
};
export var interpolate = function (values) {
    if (values === void 0) { values = {}; }
    return function (source, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ""; }
        return parse(source, values, TEMPLATE_PARSER_OPTS, defaultValue);
    };
};
export var Markdown = function (_a) {
    var staticContent = _a.staticContent, _b = _a.values, values = _b === void 0 ? {} : _b, source = _a.source, transformUrl = _a.transformUrl;
    var overrides = {
        a: function (props) { return React.createElement("span", null, props.children); },
        "res:icon": function (props) { return React.createElement(IconRenderer, __assign({}, props)); },
        "res:date": function (props) { return React.createElement(DateRenderer, __assign({}, props, { values: values })); },
        "res:link": function (props) { return (React.createElement(LinkRenderer, __assign({}, props, { values: values, transformUrl: transformUrl }))); },
        "res:state": function (props) { return (React.createElement(StateNameRenderer, __assign({}, props, { values: values }))); },
        "res:modal": function (props) { return (React.createElement(ModalRenderer, __assign({}, props, { staticContent: staticContent }))); },
    };
    return (React.createElement(MD, { options: { overrides: overrides } }, stripHtml(interpolate(values)(source), {
        ignoreTags: ["res", "a"],
    })));
};
